import * as THREE from "three";

export const StiegenLabels = [
  {
    Id: "Annotation_OriginalStiege",
    Titel: "Bronzezeitliche Stiege",
    TitelEn: "Bronze Age wooden staircase",
    Position: new THREE.Vector3(-600, 25, -690),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 2,
    isIFrame: true,
    iFrameUrl: "https://sketchfab.com/models/57deba9ab2904d0ab009ac238073ab05/embed",
    offset: 20,
    offsetUp: 0,
    follow: false
  },

];

export const GraeberLabelsF = [
  {
    Id: "Annotation_BronzeArmring",
    Titel: "Bronzener Armring",
    TitelEn: "Bronze bangle",
    Position: new THREE.Vector3(-1513.86, 28.7627, -482.67),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/72803e88932c43b29758e03121a92894/embed",
    offset: 18,
    offsetUp: 0,
    lowModelCamZoom: 35,
    follow: true
  },

  {
    Id: "Annotation_Brillenfibel",
    Titel: "Brillenfibel",
    TitelEn: "Bronze spectacle brooch",
    Position: new THREE.Vector3(-1508.94, 28.5596, -430.24),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/5ce7c01fb5d54c798d77515f8bd22e7d/embed",
    offset: -16,
    offsetUp: 0,
    lowModelCamZoom: 20,
    follow: true
  },
];

export const GraeberLabelsM = [
  {
    Id: "Annotation_Tuellenbeil",
    Titel: "Tüllenbeil",
    TitelEn: "Iron socketed axe",
    Position: new THREE.Vector3(-1508.4, 51.2947, -277.634),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/f3769f30d1ed4615998849d70c5255f7/embed",
    offset: -12,
    offsetUp: 0,
    lowModelCamZoom: 25,
    follow: true
  },

  {
    Id: "Annotation_Situla",
    Titel: "Situla",
    TitelEn: "Situla",
    Position: new THREE.Vector3(-1510.03, 36.6302, -248.429),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/b7ec01e6fd294db1aacb199b1ec96a5f/embed",
    offset: -14,
    offsetUp: 0,
    lowModelCamZoom: 40,
    follow: true
  },
  {
    Id: "Annotation_Lanzenspitze",
    Titel: "Kleine Lanzenspitze",
    TitelEn: "Small lance tip",
    Position: new THREE.Vector3(-1510.37, 58.4841, -359.352),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/8efcc73a41fd465cb02738f5ccd1c229/embed",
    offset: 11,
    offsetUp: 0,
    lowModelCamZoom: 60,
    follow: true
  },
  {
    Id: "Annotation_EiserneSpeerspitze",
    Titel: "Große Lanzenspitze",
    TitelEn: "Large lance tip",
    Position: new THREE.Vector3(-1509.19, 19.9721, -359.605),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/d6325534296449829eab5e83cb636842/embed",
    offset: 17,
    offsetUp: 0,
    lowModelCamZoom: 30,
    follow: true
  },
  {
    Id: "Annotation_EisenbeilHolzstueck",
    Titel: "Eisernes Tüllenbeil",
    TitelEn: "Iron socketed axe",
    Position: new THREE.Vector3(-1490.89, 42.1761, -368.0),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/94354368f43844c8bd7b07939a8f3c93/embed",
    offset: -18,
    offsetUp: 0,
    lowModelCamZoom: 50,
    follow: true
  },

  {
    Id: "Annotation_EisenSchwert",
    Titel: "Prunkschwert",
    TitelEn: "Elegant iron sword",
    Position: new THREE.Vector3(-1508.4, 49.6967, -383.838),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/12fad46112dc4b308f892a58791000b3/embed",
    offset: 14,
    offsetUp: 0,
    lowModelCamZoom: 50,
    follow: true
  },

  {
    Id: "Annotation_Mehrkopfnadel",
    Titel: "Mehrkopfnadel",
    TitelEn: "Multi-headed needle",
    Position: new THREE.Vector3(-1495.06, 6.41384, -319.507),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/8c8f1b849d8441deb75251f96c8458d0/embed",
    offset: 14,
    offsetUp: 0,
    lowModelCamZoom: 30,
    follow: true
  },

  {
    Id: "Annotation_Breitrandschale",
    Titel: "Breitrandschale",
    TitelEn: "Broad-rimmed bowl",
    Position: new THREE.Vector3(-1508.4, 21.4401, -273.488),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/281f2db5ee294c3d86eaac9b27d23d45/embed",
    offset: -23,
    offsetUp: -6,
    lowModelCamZoom: 50,
    follow: true
  },
];

export const SalzEntAmmonit = [
  {
    // Id muss den Modell-/Titel-Namen treffen (AmmonitenArt, siehe
    // stateArtefacts.jsx) — das speist sowohl ModelViewerActivation als auch
    // die Label-Versteck-Logik in Annotation.jsx (clickHintArtefaktTitels).
    Id: "Annotation_AmmonitenArt",
    Titel: "Ammoniten",
    TitelEn: "Ammonites",
    Position: new THREE.Vector3(-483.385, 0.0, -283.799),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "",
    offset: 15,
    offsetUp: 19,
    lowModelCamZoom: 15,
    follow: true
  },
];

export const BronzezeitLabels = [
  {
    Id: "Annotation_Tragesack",
    Titel: "Tragesack",
    TitelEn: "Bronze Age carrysack",
    Position: new THREE.Vector3(-925.062, 4.00785, -612.063),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/3dac341447aa4ffa94efa2b8ec69dc0c/embed",
    offset: 15,
    offsetUp: 15,
    lowModelCamZoom: 30,
    follow: true
  },

  {
    Id: "Annotation_Fellmuetze",
    Titel: "Ledermütze",
    TitelEn: "Leather hat",
    Position: new THREE.Vector3(-977.419, 4.00785, -612.063),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/bad3d9bd89f7458aad8e93ee3d784597/embed",
    offset: 15,
    offsetUp: 15,
    lowModelCamZoom: 15,
    follow: true
  },
  {
    Id: "Annotation_SignalHorn",
    Titel: "Signalhorn",
    TitelEn: "Bugle",
    Position: new THREE.Vector3(-1029.78, 4.00785, -612.063),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/4d42ea9c458644e7a99b522499a817dd/embed",
    offset: 15,
    offsetUp: 15,
    follow: true
  },

  {
    Id: "Annotation_HandlederRechteckig",
    Titel: "Handleder",
    TitelEn: "Leather palm",
    Position: new THREE.Vector3(-1055.95, 4.00785, -681.051),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/8853b8b7f9284b228404b98f7eeb6bea/embed",
    offset: 15,
    offsetUp: 19,
    lowModelCamZoom: 15,
    follow: true
  },

  {
    Id: "Annotation_Leuchtspanbuendel",
    Titel: "Leuchtspanbündel",
    TitelEn: "Lighting tapers",
    Position: new THREE.Vector3(-1003.6, 4.00785, -681.051),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/886bce74345e46f7920184b43f6f3e90/embed",
    offset: 15,
    offsetUp: 19,
    lowModelCamZoom: 20,
    follow: true
  },

  {
    Id: "Annotation_Kuebel",
    Titel: "Holzeimer",
    TitelEn: "Wooden bucket",
    Position: new THREE.Vector3(-951.241, 4.00785, -681.051),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/fe8eb04f5d8c4f169a63f5c97cf92270/embed",
    offset: 15,
    offsetUp: 19,
    lowModelCamZoom: 15,
    follow: true
  },

  {
    Id: "Annotation_Kratze",
    Titel: "Kratze",
    TitelEn: "wooden scraper",
    Position: new THREE.Vector3(-898.884, 4.00785, -681.051),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/abfc8a8108394978adafde013451bc6d/embed",
    offset: 15,
    offsetUp: 19,
    lowModelCamZoom: 15,
    follow: true
  },
];

export const EisenzeitLabels = [
  {
    Id: "Annotation_AntennendolchHaengend",
    Titel: "Prunkdolch",
    TitelEn: "Ornate dagger",
    Position: new THREE.Vector3(-1395.06, 4.00785, -171.027),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/1c51fd7dcffa41c5b596e62eeb0e6c31/embed",
    offset: 15,
    offsetUp: 19,
    lowModelCamZoom: 15,
    follow: true
  },
  
  {
    Id: "Annotation_Bergwerkschuh",
    Titel: "Lederschuh",
    TitelEn: "Leather shoe",
    Position: new THREE.Vector3(-1343.46, 4.01, -171.027),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "",
    offset: 15,
    offsetUp: 19,
    lowModelCamZoom: 15,
    follow: true
  },

  {
    Id: "Annotation_Bronzehalsring",
    Titel: "Bronzehalsreif",
    TitelEn: "Bronze neck ring",
    Position: new THREE.Vector3(-1443.56, 4.00785, -171.027),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/9f752faf472142c89062b015d019f500/embed",
    offset: 15,
    offsetUp: 19,
    lowModelCamZoom: 15,
    follow: true
  },
  {
    Id: "Annotation_Kuhkaelbchenschale",
    Titel: "Ritualgefäß",
    TitelEn: "Ceremonial vessel",
    Position: new THREE.Vector3(-1292.2, 4.00785, -171.027),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "",
    offset: 15,
    offsetUp: 19,
    lowModelCamZoom: 15,
    follow: true
  },
  {
    Id: "Annotation_Deckel",
    Titel: "Bronzedeckel",
    TitelEn: "Bronze lid",
    Position: new THREE.Vector3(-1515.49, 4.00785, -566.933),
    Rotation: new THREE.Vector3(0.0, 0.0, -90),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/aac970e043e244b2b9348fb3593008f3/embed",
    offset: 0,
    offsetUp: 25,
    lowModelCamZoom: 20,
    follow: false
  },

  {
    Id: "Annotation_Stierhornschenkelschale",
    Titel: "Stierkopftasse",
    TitelEn: "Bull's head cup",
    Position: new THREE.Vector3(-1515.49, 4.00785, -696.856),
    Rotation: new THREE.Vector3(0.0, 0.0, -90),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "",
    offset: 0,
    offsetUp: 30,
    lowModelCamZoom: 25,
    follow: false
  },


];

export const ModernerBergbauLables = [
  {
    Id: "Annotation_WallPicSalzfabrik",
    Titel: "Galerie Saline",
    TitelEn: "Saltworks gallery",
    Position: new THREE.Vector3(-700.156, 36.7137, 300.9),
    Rotation: new THREE.Vector3(0.0, 0.0,90),
    Scale: 1.3,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetUp: 0,
    follow: false
  },

  {
    Id: "Annotation_WallPicSalzTaetigkeit",
    Titel: "Galerie Salztätigkeit",
    TitelEn: "Salting work gallery",
    Position: new THREE.Vector3(-990.071, 32.6844, 470.443),
    Rotation: new THREE.Vector3(0.0, 0.0, -90),
    Scale: 1.3,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetUp: 0,
    follow: false
  },



  {
    Id: "Annotation_Lampe",
    Titel: "Lampe",
    TitelEn: "Lamp",
    Position: new THREE.Vector3(-987.651, 4.01, 271.448),
    Rotation: new THREE.Vector3(0.0, 0.0, -90),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/c9d69f317ee5470f9fe964e2698ccd16/embed",
    offset: 0,
    offsetUp: 30,
    follow: false,
    lowModelCamZoom: 35
  },

  {
    Id: "Annotation_Salzfabrik",
    Titel: "Saline in Ebensee",
    TitelEn: "Saltworks in Ebensee",
    Position: new THREE.Vector3(-719.172, 7.9514, 260.176),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/74e038ccaa4d41c9b9a5cbcbe07327ee/embed",
    offset: 0,
    offsetUp: 30,
    follow: true,
    lowModelCamZoom: 25
  },

  {
    Id: "Annotation_Solepfanne",
    Titel: "Das Pfannhaus",
    TitelEn: "The saltworks",
    Position: new THREE.Vector3(-719.172, 7.9514, 381.6),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/8901ea6f6f934df6898fd0105489c4b2/embed",
    offset: 0,
    offsetUp: 45,
    follow: true,
    lowModelCamZoom: 25
  },

  {
    Id: "Annotation_Stollenschachtmodell",
    Titel: "Bergwerksschacht",
    TitelEn: "Mine shaft",
    Position: new THREE.Vector3(-990.742, 40.5042, 340.126),
    Rotation: new THREE.Vector3(0.0, 0.0, -90),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/664ad3e2838d481891ac9b3bc0c20a17/embed",
    offset: 0,
    offsetUp: -10,
    follow: false
  },

  {
    Id: "Annotation_Bohrkopf",
    Titel: "Teilschnittmaschine",
    TitelEn: "Roadheader",
    Position: new THREE.Vector3(-910, 4.01, 651.159),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "",
    offset: 20,
    offsetUp: 30,
    follow: true,
    lowModelCamZoom: 2.5
  },

  {
    Id: "Annotation_ModerenesGeleuchtKopflampe",
    Titel: "Der Schutzhelm",
    TitelEn: "The safety helmet",
    Position: new THREE.Vector3(-843.946, 4.01, 661.707),
    Rotation: new THREE.Vector3(0.0, 0.0, 180),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/4854a33ebe384ad8b43fcbeb59f59266/embed",
    offset: 0,
    offsetUp: 30,
    follow: false
  },



 

];

export const MittelalterLabels = [
  {
    Id: "Annotation_GalerieFuerstenzimmer",
    Titel: "Galerie Fürstenzimmer",
    TitelEn: "Prince's Room Gallery",
    Position: new THREE.Vector3(-1324.75, 36.925, -25.2695),
    Rotation: new THREE.Vector3(0.0, 0.0,-90),
    Scale: 1.3,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetUp: 0,
    follow: false
  },

  {
    Id: "Annotation_EbenseeSoleleitung",
    Titel: "Soleleitung",
    TitelEn: "Brine conduit",
    Position: new THREE.Vector3(-1129.95, 15.8823, 121.696,),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "",
    offset: 0,
    offsetUp: 8,
    follow: true
  },

  {
    Id: "Annotation_Salzschaufel",
    Titel: "Salzschaufel",
    TitelEn: "Salt shovel",
    Position: new THREE.Vector3(-1179.13, 4.01, 22.5972),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/74d95ee3575b4d26acc8a5a9ecfce10c/embed",
    offset: 15,
    offsetUp: 20,
    follow: true,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_ReformationslibellOffen",
    Titel: "Reformationslibell",
    TitelEn: "Reformationslibell",
    Position: new THREE.Vector3(-1179.13, 4.01, -31.8695),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/7596dffff944437c9f9fa6c580252af1/embed",
    offset: 27,
    offsetUp: 20,
    follow: true,
    lowModelCamZoom: 10
  },


];

export const SteinzeitLabels = [
  {
    Id: "Annotation_Talglampe",
    Titel: "Talglampe",
    TitelEn: "Tallow lamp",
    Position: new THREE.Vector3(-310.243, 15.2587, -530.971),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/598342ddfb4440a5896e96c1af2e419b/embed",
    offset: 0,
    offsetUp: 20,
    follow: true
  },

  {
    Id: "Annotation_SteinzeitHirschhaue",
    Titel: "Hirschgeweihpickel",
    TitelEn: "Pick made of deer antler",
    Position: new THREE.Vector3(-336.669, 4.00785, -627.658),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/ca65626e979341489c94972d84d7d06a/embed",
    offset: 0,
    offsetUp: 30,
    follow: true,
    lowModelCamZoom: 0.8
  },

  {
    Id: "Annotation_Steinbeil",
    Titel: "Steinbeil",
    TitelEn: "Stone axe",
    Position: new THREE.Vector3(-367.827, 4.00785, -424.627),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "",
    offset: 0,
    offsetUp: 30,
    follow: true,
    lowModelCamZoom: 15
  },


];

  export const  ToursimustLabels = [
    {
      Id: "Annotation_Grubenhund",
      Titel: "Grubenhunt",
      TitelEn: "Mine wagon",
      Position: new THREE.Vector3(-516.464, 8.0098, 269.966),
      Rotation: new THREE.Vector3(0.0, 0.0,0),
      Scale: 1.3,
      isIFrame: true,
      iFrameUrl:
        "https://sketchfab.com/models/78ea22cdda8f406c821285ed1cda4a76/embed",
      offset: 0,
      offsetUp: 25,
      follow: true,
      lowModelCamZoom: 15
    },

    {
      Id: "Annotation_PicGalerieFremdfahrt",
      Titel: "Fremdenbefahrung",
      TitelEn: "Guided tours",
      Position: new THREE.Vector3(-369.897, -6, 308.712),
      Rotation: new THREE.Vector3(0.0, 0,90),
      Scale: 1.3,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/78ea22cdda8f406c821285ed1cda4a76/embed",
      offset: 0,
      offsetUp: 25,
      follow: false,
      lowModelCamZoom: 15
    },

    {
      Id: "Annotation_PicGalerieRutschen",
      Titel: "Eine Rutschpartie",
      TitelEn: "A slide down",
      Position: new THREE.Vector3(-369.897, 22.5362, 245.553),
      Rotation: new THREE.Vector3(0.0, 0,90),
      Scale: 1.3,
      isIFrame: false,
      iFrameUrl:
        "https://sketchfab.com/models/78ea22cdda8f406c821285ed1cda4a76/embed",
      offset: 0,
      offsetUp: -5,
      follow: false,
      lowModelCamZoom: 15
    }



];

export const  SalzgewinnungLabels = [
  {
    Id: "Annotation_Uebersicht",
    Titel: "Video Bohrlochsonde",
    TitelEn: "Borehole probe Video",
    Position: new THREE.Vector3(-739.627, 33.5699, 546.832),
    Rotation: new THREE.Vector3(0.0, 0.0,90),
    Scale: 1,
    isIFrame: true,
    iFrameUrl:
      "https://www.youtube.com/embed/8m9QiC4JWRc?rel=0&autoplay=1&amp&;controls=0",
    offset: -15,
    offsetUp: -5,
    follow: false,
    lowModelCamZoom: 15
  },



];





export const  SteinzeitPickelLabel  = [
  {
    Id: "Annotation_Hirschgeweihpickel",
    Titel: "Hirschgeweihpickel",
    TitelEn: "Pick made of deer antler",
    Position: new THREE.Vector3(-770, 40, -85.8374),
    Rotation: new THREE.Vector3(0.0, 0.0,-90),
    Scale: 1.5,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 50,
    offsetx: 50,
    offsetUp: -20,
    follow: false,
    lowModelCamZoom: 15
  },


];


export const  BronzezeitlicherPickelLabel  = [
  {
    Id: "Annotation_BronzezeitlicherPickel",
    Titel: "Bronzezeitlicher Pickel",
    TitelEn: "Bronze picks",
    Position: new THREE.Vector3(-770, 40, -85.8374),
    Rotation: new THREE.Vector3(0.0, 0.0,-90),
    Scale: 1.5,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 50,
    offsetx: 50,
    offsetUp: -20,
    follow: false,
    lowModelCamZoom: 15
  },


]


export const  EisenzeitlicherPickelLabel   = [
  {
    Id: "Annotation_EisenzeitlicherPickel",
    Titel: "Eisenzeitlicher Pickel",
    TitelEn: "Iron Age picks",
    Position: new THREE.Vector3(-770, 40, -85.8374),
    Rotation: new THREE.Vector3(0.0, 0.0,-90),
    Scale: 1.5,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 50,
    offsetx: 50,
    offsetUp: -20,
    follow: false,
    lowModelCamZoom: 15
  },


];

export const  BergeisenLabel   = [
  {
    Id: "Annotation_Bergeisen",
    Titel: "Bergeisen",
    TitelEn: "Mining iron",
    Position: new THREE.Vector3(-770, 40, -85.8374),
    Rotation: new THREE.Vector3(0.0, 0.0,-90),
    Scale: 1.5,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 50,
    offsetx: 50,
    offsetUp: -20,
    follow: false,
    lowModelCamZoom: 15
  },


];

export const  HammerSchlegelLabel   = [
  {
    Id: "Annotation_HammerSchlege",
    Titel: "Schlägel und Eisen",
    TitelEn: "Hammer and pick",
    Position: new THREE.Vector3(-770, 40, -85.8374),
    Rotation: new THREE.Vector3(0.0, 0.0,-90),
    Scale: 1.5,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 50,
    offsetx: 50,
    offsetUp: -20,
    follow: false,
    lowModelCamZoom: 15
  },


];

export const  BohrhammerLabel   = [
  {
    Id: "Annotation_Bohrhammer",
    Titel: "Bohrhammer",
    TitelEn: "Hammer drill",
    Position: new THREE.Vector3(-770, 40, -85.8374),
    Rotation: new THREE.Vector3(0.0, 0.0,-90),
    Scale: 1.5,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 50,
    offsetx: 50,
    offsetUp: -20,
    follow: false,
    lowModelCamZoom: 15
  },


];

export const  TeilschnittmaschineLabel   = [
  {
    Id: "Annotation_Teilschnittmaschine",
    Titel: "Teilschnittmaschine",
    TitelEn: "Roadheader",
    Position: new THREE.Vector3(-770, 40, -85.8374),
    Rotation: new THREE.Vector3(0.0, 0.0,-90),
    Scale: 1.5,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 50,
    offsetx: 50,
    offsetUp: -20,
    follow: false,
    lowModelCamZoom: 15
  },


];


export const  BzLebensbildLabels   = [
  {
    Id: "Annotation_BZ_Trinkbehaeltnis",
    Titel: "Trinkbehältnis",
    TitelEn: "Drinking receptacle",
    Position: new THREE.Vector3(-841.93, 57.8083, -720.535),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_BZ_Tragesack",
    Titel: "Tragesack",
    TitelEn: "Carrysack",
    Position: new THREE.Vector3(-866.158, 45.1184, -720.535),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_BZ_stiege",
    Titel: "Stiege",
    TitelEn: "Staircases",
    Position: new THREE.Vector3(-893.209, 64.2329, -720.535),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_BZ_speck",
    Titel: "Speck",
    TitelEn: "Bacon",
    Position: new THREE.Vector3(-857.822, 75.9195, -720.535),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_BZ_Seil",
    Titel: "Seil",
    TitelEn: "Rope",
    Position: new THREE.Vector3(-890.78, 81.1783, -720.535),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_BZ_Arbeitsgewand",
    Titel: "Arbeitskleidung",
    TitelEn: "Work clothing",
    Position: new THREE.Vector3(-802.785, 68.5845, -720.535),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_BZ_Pickel",
    Titel: "Pickel",
    TitelEn: "Pick",
    Position: new THREE.Vector3(-810.135, 37.1501, -720.535),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_BZ_Leuchtspaene",
    Titel: "Leuchtspäne",
    TitelEn: "Lighting tapers",
    Position: new THREE.Vector3(-898.276, 24.7055, -720.535),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_BZ_Kratze",
    Titel: "Kratze",
    TitelEn: "Scraper",
    Position: new THREE.Vector3(-831.996, 37.1501, -720.535),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_BZ_Kappe",
    Titel: "Kappe",
    TitelEn: "Cap",
    Position: new THREE.Vector3(-862.424, 28.128, -720.535),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },
  {
    Id: "Annotation_BZ_Heidengebirge",
    Titel: "Heidengebirge",
    TitelEn: "Heidengebirge",
    Position: new THREE.Vector3(-852.659, 37.9693, -720.535),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_BZ_Grubenhoelzer",
    Titel: "Grubenhölzer",
    TitelEn: "Timber support",
    Position: new THREE.Vector3(-872.118, 69.324, -720.535),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_BZ_Fuelltrog",
    Titel: "Fülltrog",
    TitelEn: "Filling-trough",
    Position: new THREE.Vector3(-872.118, 69.324, -720.535),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },
  


];



export const  EzLebensbildLabels   = [
  {
    Id: "Annotation_EZ_unlkareHackspuren",
    Titel: "Unklare Hackspuren",
    TitelEn: "Unclear hatch marks",
    Position: new THREE.Vector3(-1341.19, 28.212, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_Tragen",
    Titel: "Tragen",
    TitelEn: "Carrying",
    Position: new THREE.Vector3(-1342.49, 54.5911, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_Textilfunde",
    Titel: "Textilfunde",
    TitelEn: "Textile finds",
    Position: new THREE.Vector3(-1299.37, 39.4966, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_Steigbaum",
    Titel: "Steigbaum",
    TitelEn: "Climbing tree",
    Position: new THREE.Vector3(-1357.55, 69.8308, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_Schuhe",
    Titel: "Schuhe",
    TitelEn: "Shoes",
    Position: new THREE.Vector3(-1351.43, 19.4956, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_Salzherzen",
    Titel: "Salzherzen",
    TitelEn: "Salt hearts",
    Position: new THREE.Vector3(-1376.87, 38.3681, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_Ritschert",
    Titel: "Ritschert",
    TitelEn: "Staple food „Ritschert“",
    Position: new THREE.Vector3(-1309.63, 34.6168, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_Pickel",
    Titel: "Pickel",
    TitelEn: "Pick",
    Position: new THREE.Vector3(-1350.39, 77.7087, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_Nahrungsmittel",
    Titel: "Nahrungsmittel",
    TitelEn: "Food",
    Position: new THREE.Vector3(-1312.98, 15.541, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_Faekalien",
    Titel: "Fäkalien",
    TitelEn: "Feces",
    Position: new THREE.Vector3(-1318.05, 59.2811, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_LeuchtspaeneNeu",
    Titel: "Leuchtspanbündel",
    TitelEn: "Lighting tapers",
    Position: new THREE.Vector3(-1277.44, 30.2858, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_Leuchtspaene",
    Titel: "Leuchtspäne",
    TitelEn: "Lighting tapers",
    Position: new THREE.Vector3(-1370.96, 16.0854, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_KleiderLaeuse",
    Titel: "Kleiderläuse",
    TitelEn: "Clothing lice",
    Position: new THREE.Vector3(-1322.08, 26.9952, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_KinderImBerg",
    Titel: "Kinder im Berg",
    TiteEn: "Children in the mine",
    Position: new THREE.Vector3(-1353.82, 47.8538, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },

  {
    Id: "Annotation_EZ_Grubenfeuer",
    Titel: "Grubenfeuer",
    TitelEn: "Underground fire",
    Position: new THREE.Vector3(-1306.62, 27.8503, -742.206),
    Rotation: new THREE.Vector3(0.0, 0.0,0),
    Scale: 1,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetx: 0,
    offsetUp: 0,
    follow: false,
    lowModelCamZoom: 15
  },
];

